import { apiFetch, validateInviteToken as _validateInviteToken } from './auth-service';

export interface InviteRecord {
  _id: string;
  token: string;
  email: string;
  name: string;
  role: 'mentor' | 'investor';
  status: 'pending' | 'used' | 'revoked' | 'expired';
  expiresAt: string;
  usedBy?: string | null;
  usedAt?: string | null;
  createdAt: string;
}

export interface GenerateInviteResult {
  invite: InviteRecord;
  link: string;
}

export const generateMentorInvite = async (email: string, name: string): Promise<GenerateInviteResult> => {
  const r = await apiFetch.post<{ invite: InviteRecord; link: string; mail: any }>('/invites/mentor', { email, name });
  return { invite: r.invite, link: r.link };
};

export const generateInvestorInvite = async (email: string, name: string): Promise<GenerateInviteResult> => {
  const r = await apiFetch.post<{ invite: InviteRecord; link: string; mail: any }>('/invites/investor', { email, name });
  return { invite: r.invite, link: r.link };
};

export const validateInvite = async (token: string) => {
  return _validateInviteToken(token);
};

export const getMyInvites = async () => {
  const r = await apiFetch.get<{ invites: InviteRecord[] }>('/invites');
  return r.invites;
};

export const revokeInvite = async (id: string) => {
  const r = await apiFetch.post<{ invite: InviteRecord }>(`/invites/${id}/revoke`);
  return r.invite;
};
